import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { FaCalendarAlt, FaWallet, FaRupeeSign } from "react-icons/fa";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { useNavigate, Link, useParams } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { FiMoreHorizontal, FiArrowLeft, FiArrowRight } from "react-icons/fi";
import Bluedart from "../../assets/bluedart.png";
import Delehivery from "../../assets/delehivery.png";
import EcomExpress from "../../assets/ecom-expresss.avif";
import Shadowfax from "../../assets/shadowfax.png";
import Xpressbees from "../../assets/xpressbees.png";
import Shiprocket from "../../assets/shiprocket.webp";
import NimbusPost from "../../assets/nimbuspost.webp";
import ShreeMaruti from "../../assets/shreemaruti.png";
import DTDC from "../../assets/dtdc.png";
import Amazon from "../../assets/amazon.jpg";
import ThreeDotLoader from "../../Loader";
import { FaInfoCircle } from "react-icons/fa";

const Passbooks = () => {
  const [transactions, setTransactions] = useState([]);
  const [userQuery, setUserQuery] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [dateRange, setDateRange] = useState("");
  const [category, setCategory] = useState("");
  const [awbNumber, setAwbNumber] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [orderId, setOrderId] = useState("");
  const [customDateLabel, setCustomDateLabel] = useState("");
  const dateDropdownRef = useRef(null);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showSearchTypeDropdown, setShowSearchTypeDropdown] = useState(false);
  const [customRange, setCustomRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [loading, setLoading] = useState(true);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const categoryRef = useRef();
  const navigate = useNavigate();
  const searchTypeRef = useRef(null);
  const [searchType, setSearchType] = useState("awbNumber");
  const [searchInput, setSearchInput] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);
  const { id } = useParams();
  const carrierLogos = {
    Bluedart,
    Delhivery: Delehivery,
    EcomExpress,
    Shadowfax,
    Xpressbees,
    NimbusPost,
    Shiprocket,
    ShreeMaruti,
    DTDC,
    Amazon,
  };
  // Sync searchInput into actual filter fields
  useEffect(() => {
    if (searchType === "orderId") {
      setOrderId(searchInput);
      setAwbNumber("");
    } else {
      setAwbNumber(searchInput);
      setOrderId("");
    }
  }, [searchInput, searchType]);

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoryRef.current &&
        !categoryRef.current.contains(event.target) &&
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target) &&
        searchTypeRef.current &&
        !searchTypeRef.current.contains(event.target)
      ) {
        setShowCategoryDropdown(false);
        setShowDateDropdown(false);
        setShowSearchTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getDateRange = () => {
    const today = dayjs();
    switch (dateRange) {
      case "today":
        return {
          fromDate: today.startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };
      case "yesterday":
        return {
          fromDate: today.subtract(1, "day").startOf("day").toISOString(),
          toDate: today.subtract(1, "day").endOf("day").toISOString(),
        };
      case "last5days":
        return {
          fromDate: today.subtract(5, "day").startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };
      case "thisMonth":
        return {
          fromDate: today.startOf("month").toISOString(),
          toDate: today.endOf("month").toISOString(),
        };
      case "lastMonth":
        const lastMonth = today.subtract(1, "month");
        return {
          fromDate: lastMonth.startOf("month").toISOString(),
          toDate: lastMonth.endOf("month").toISOString(),
        };
      case "custom":
        return {
          fromDate: customRange[0].startDate.toISOString(),
          toDate: customRange[0].endDate.toISOString(),
        };
      default:
        return {};
    }
  };

  const fetchTransactions = async () => {
    try {
      const [_, token] = document.cookie.split("=");
      const { fromDate, toDate } = getDateRange();
      setLoading(true);
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/order/passbook`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            id,
            // userSearch: selectedUserId || "",
            fromDate,
            toDate,
            category,
            page,
            limit,
            orderId,
            awbNumber,
          },
        }
      );
      console.log("trans", response.data);
      setTransactions(response.data.results || []);

      setTotalPages(response.data.page || 0);
      setLoading(false);
    } catch (error) {
      toast.error("Error fetching transactions");
    }
  };

  const handleApplyCustomDate = () => {
    setShowCalendar(false);
    const start = dayjs(customRange[0].startDate).format("MMM D");
    const end = dayjs(customRange[0].endDate).format("MMM D");

    setCustomDateLabel(`${start} - ${end}`);
    setDateRange("custom"); // Ensure it's always "custom"
    fetchTransactions();
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;

    // If the selected value is "custom"
    if (value === "custom") {
      // Toggle the calendar visibility
      setShowCalendar(!showCalendar);
    } else {
      setShowCalendar(false); // Hide calendar for other selections
    }

    setDateRange(value);
  };

  // Close calendar on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleTrackingByAwb = (awb) => {
    navigate(`/dashboard/order/tracking/${awb}`);
  };

  useEffect(() => {
    fetchTransactions();
  }, [selectedUserId, dateRange, page, limit, category, orderId, awbNumber]);

  // At the top of PassBook.jsx, after imports:
  const ChargeBreakdownModal = ({ open, onClose, details }) => {
    if (!open || !details) return null;
    const w = details.working || details; // fallback for direct working object
    const displayValue = (v) =>
      v === undefined || v === null || v === "" ? "-" : v;
    const rows = [
      {
        label: "Chargeable Wt.",
        value: w.chargeable_weight ? `${w.chargeable_weight} kg` : "-",
      },
      { label: "Rate", value: w.rate != null ? `₹${w.rate}` : "-" },
      { label: "Freight", value: w.freight != null ? `₹${w.freight}` : "-" },
      {
        label: "Handling Charges",
        value: w.handling_charges != null ? `₹${w.handling_charges}` : "-",
      },
      { label: "ODA", value: w.oda != null ? `₹${w.oda}` : "-" },
      { label: "FSC", value: w.fsc != null ? `₹${w.fsc}` : "-" },
      {
        label: "AWB Charges",
        value: w.awb_charges != null ? `₹${w.awb_charges}` : "-",
      },
      { label: "ROV", value: w.rov != null ? `₹${w.rov}` : "-" },
      {
        label: "COD Charges",
        value: w.cod_charges != null ? `₹${w.cod_charges}` : "-",
      },
      {
        label: "FM Charges",
        value: w.fm_charges != null ? `₹${w.fm_charges}` : "-",
      },
      {
        label: "Total (before GST)",
        value: w.total != null ? `₹${w.total}` : "-",
      },
      { label: "GST", value: w.gst != null ? `₹${w.gst}` : "-" },
      {
        label: "Estimated Grand Total",
        value: w.grand_total != null ? `₹${w.grand_total}` : "-",
      },
    ];
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white rounded-lg w-full max-w-md p-6 relative shadow-lg">
          <h2 className="text-lg font-bold mb-2 text-gray-700">
            Rate Breakdown
          </h2>
          <div className="max-h-96 overflow-y-auto">
            <table className="w-full text-sm">
              <tbody>
                {rows.map((r, idx) => (
                  <tr key={idx}>
                    <td className="pr-2 py-1 text-gray-600 whitespace-nowrap">
                      {r.label}
                    </td>
                    <td className="font-semibold py-1 text-right text-gray-700">
                      {r.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            className="mt-4 w-full bg-[#0CBB7D] text-white rounded py-2 font-bold"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-2">
      {/* Filter Section */}
      <div className="sm:flex gap-2 relative justify-between">
        <div className="flex sm:flex-row w-full flex-col gap-2">
          <div className="relative">
            <div className="flex items-center h-9 border-2 border-gray-300 rounded-lg bg-white">
              {/* Dropdown Trigger with ref wrapper */}
              <div className="relative h-full" ref={searchTypeRef}>
                <button
                  type="button"
                  onClick={() => setShowSearchTypeDropdown((prev) => !prev)}
                  className="flex items-center w-24 justify-between px-2 h-full text-gray-600 text-[12px] font-semibold border-r"
                >
                  <span>{searchType === "awbNumber" ? "Waybill" : "Order ID"}</span>
                  <ChevronDown className="w-3 h-3 ml-1" />
                </button>

                {/* Dropdown inside ref wrapper */}
                {showSearchTypeDropdown && (
                  <ul className="absolute z-10 mt-1 w-24 bg-white border border-gray-300 rounded-lg text-[12px] font-[600] text-gray-600">
                    {["awbNumber", "orderId"].map((type) => (
                      <li
                        key={type}
                        className={`px-3 py-2 cursor-pointer hover:bg-green-100 ${
                          searchType === type ? "bg-gray-100 font-[600]" : ""
                        }`}
                        onClick={() => {
                          setSearchType(type);
                          setShowSearchTypeDropdown(false);
                          setSearchInput("");
                        }}
                      >
                        {type === "awbNumber" ? "Waybill No." : "Order ID"}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Input Field */}
              <input
                type="text"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder={`Search ${
                  searchType === "awbNumber" ? "Waybill Number" : "Order ID"
                }`}
                className="px-3 text-[12px] font-[600] border-l-0 rounded-r-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
              />
            </div>
          </div>
          <div className="flex w-full sm:justify-between gap-2">
            <div className="flex gap-2 w-full sm:w-auto">
              {/* Date Range Dropdown */}
              <div className="relative w-full" ref={dateDropdownRef}>
                <button
                  onClick={() => setShowDateDropdown((prev) => !prev)}
                  className="w-full sm:w-[100px] h-9 px-3 border-2 rounded-lg font-[600] text-gray-500 text-left sm:text-[12px] text-[12px] bg-white flex items-center justify-between"
                  type="button"
                >
                  {customDateLabel || "Dates"}
                  <ChevronDown
                    className={`w-4 h-4 transform transition-transform ${
                      showDateDropdown ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {showDateDropdown && (
                  <ul className="absolute sm:w-[100px] z-30 w-full font-[600] text-gray-500 mt-1 bg-white border rounded-lg overflow-y-auto text-[12px]">
                    {[
                      { value: "today", label: "Today" },
                      { value: "yesterday", label: "Yesterday" },
                      { value: "last5days", label: "Last 5 Days" },
                      { value: "thisMonth", label: "This Month" },
                      { value: "lastMonth", label: "Last Month" },
                      {
                        value: "custom",
                        label: customDateLabel
                          ? `Custom: ${customDateLabel}`
                          : "Custom",
                      },
                    ].map((item) => (
                      <li
                        key={item.value || "default"}
                        className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                          dateRange === item.value
                            ? "bg-gray-100 font-medium"
                            : ""
                        }`}
                        onClick={() => {
                          setDateRange(item.value);
                          setShowDateDropdown(false);
                          if (item.value === "custom") {
                            setShowCalendar(true);
                          } else {
                            setShowCalendar(false);
                          }
                        }}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Calendar Dropdown */}
                {showCalendar && (
                  <div
                    ref={calendarRef}
                    className="absolute z-30 mt-2 bg-white shadow-lg rounded p-2 w-[350px]"
                  >
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => setCustomRange([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={customRange}
                      maxDate={new Date()}
                      showDateDisplay={false}
                    />
                    <button
                      onClick={handleApplyCustomDate}
                      className="w-full mt-2 bg-[#0CBB7D] text-white text-sm py-1 px-3 rounded hover:bg-green-600"
                    >
                      Apply
                    </button>
                  </div>
                )}
              </div>
              {/* Category Filter */}
              <div className="relative" ref={categoryRef}>
                <button
                  onClick={() => setShowCategoryDropdown((prev) => !prev)}
                  className="sm:w-[100px] w-full h-9 px-3 border-2 text-gray-500 rounded-lg text-left sm:text-[12px] text-[12px] bg-white font-[600] flex justify-between items-center"
                  type="button"
                >
                  <span>{category || "Category"}</span>
                  <ChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${
                      showCategoryDropdown ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {showCategoryDropdown && (
                  <ul className="absolute sm:w-[100px] z-30 w-full mt-1 bg-white border rounded-lg text-gray-500 font-[600] overflow-y-auto text-[12px]">
                    {["credit", "debit"].map((s) => (
                      <li
                        key={s || "empty"}
                        className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                          category === s ? "bg-gray-100 font-medium" : ""
                        }`}
                        onClick={() => {
                          setCategory(s);
                          setShowCategoryDropdown(false);
                        }}
                      >
                        {s || "Category"}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            {/* Clear Button */}
            <div>
              <button
                onClick={() => {
                  setSearchType("awbNumber");
                  setSearchInput("");
                  setDateRange("");
                  setCustomRange([
                    {
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    },
                  ]);
                  setCustomDateLabel("");
                  setCategory("");
                  setShowCalendar(false);
                }}
                className="h-9 px-3 border-2 rounded-lg bg-[#0CBB7D] text-[12px] font-[600] text-white hover:bg-green-600"
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        {/* Clear Button */}
        {/* <div className="mt-2 sm:mt-0">
          <button
            onClick={() => {
              setSearchType("awbNumber");
              setSearchInput("");
              setDateRange("");
              setCustomRange([
                {
                  startDate: new Date(),
                  endDate: new Date(),
                  key: "selection"
                }
              ]);
              setCustomDateLabel("");
              setCategory("");
              setShowCalendar(false);
            }}
            className="h-9 px-3 rounded-lg bg-[#0CBB7D] text-[12px] font-[600] text-white hover:bg-green-600"
          >
            Clear
          </button>
        </div> */}
      </div>

      <div className="hidden md:block">
        <div className="overflow-x-auto">
          <table className="min-w-full text-[12px] text-left border text-gray-500 border-gray-300">
            <thead className="bg-[#0CBB7D] text-white text-[12px] font-[600]">
              <tr className="border border-[#0CBB7D]">
                <th className="px-3 py-2">Date</th>
                <th className="px-3 py-2">Order ID</th>
                <th className="px-3 py-2">Waybill Number</th>
                <th className="px-3 py-2">Category</th>
                <th className="px-3 py-2">Amount</th>
                <th className="px-3 py-2 text-center">Available Balance</th>
                <th className="px-3 py-2">Description</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan={7} className="py-6 text-center">
                    <ThreeDotLoader />
                  </td>
                </tr>
              ) : transactions.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-6 text-center text-gray-500">
                    No data found
                  </td>
                </tr>
              ) : (
                transactions.map((row, index) => (
                  <tr key={index} className="bg-white border border-gray-300">
                    <td
                      className="px-3 py-2"
                      style={{ width: "220px", maxWidth: "250px" }}
                    >
                      <p>{new Date(row.date).toLocaleTimeString()}</p>
                      <p>{new Date(row.date).toLocaleDateString()}</p>
                    </td>
                    <td
                      className="px-3 py-2"
                      style={{ width: "220px", maxWidth: "250px" }}
                    >
                      <Link
                        to={`/dashboard/order/neworder/updateOrder/${Number(
                          row.orderId
                        )}`}
                        className="text-[#0CBB7D] font-medium"
                      >
                        {row.orderId}
                      </Link>
                    </td>
                    <td
                      className="px-3 py-2"
                      style={{ width: "270px", maxWidth: "250px" }}
                    >
                      <p
                        className="text-[#0CBB7D] cursor-pointer"
                        onClick={() => handleTrackingByAwb(row.awb_number)}
                      >
                        {row.awb_number}
                      </p>
                    </td>
                    <td
                      className="px-3 py-2 capitalize"
                      style={{ width: "220px", maxWidth: "250px" }}
                    >
                      {row.category}
                    </td>

                    <td
                      className={`px-3 py-2 font-[600] ${
                        row.category === "debit"
                          ? "text-red-600"
                          : "text-green-600"
                      }`}
                    >
                      ₹{Number(row.amount).toFixed(2)}
                      {row.priceBreakup && (
                        <button
                          className="ml-2 text-[#0CBB7D]"
                          onClick={() => {
                            setModalDetails(
                              row.priceBreakup.working || row.priceBreakup
                            );
                            setModalOpen(true);
                          }}
                          title="Show price breakup"
                        >
                          <FaInfoCircle />
                        </button>
                      )}
                    </td>

                    <td
                      className="px-3 py-2 font-[600] text-center"
                      style={{ width: "220px", maxWidth: "250px" }}
                    >
                      ₹{Number(row.balanceAfterTransaction).toFixed(2)}
                    </td>
                    <td className="px-3 py-2">
                      <p className="font-[600]">Description:</p>
                      <p>{row?.description}</p>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="md:hidden">
        {loading ? (
          <ThreeDotLoader />
        ) : transactions.length > 0 ? (
          <div className="space-y-2">
            {transactions.map((row, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow border border-gray-200"
              >
                {/* Top content */}
                <div className="p-3 text-[12px] space-y-1">
                  {/* Date */}
                  <div className="grid grid-cols-[150px_10px_1fr] items-start text-gray-500">
                    <span className="font-[400]">Date</span>
                    <span className="text-center">:</span>
                    <span className="font-[400]">
                      {new Date(row.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  {/* Category */}
                  <div className="grid grid-cols-[150px_10px_1fr] items-start text-gray-500">
                    <span className="font-[400]">Category</span>
                    <span className="text-center">:</span>
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <span className="break-words">{row.type}</span>
                      <span
                        className={`font-semibold ${
                          row.category === "debit"
                            ? "text-red-500"
                            : "text-green-600"
                        }`}
                      >
                        {row.category === "debit" ? "-" : "+"} ₹
                        {Number(row.amount).toFixed(2)}
                        {row.priceBreakup && (
                          <button
                            className="ml-2 text-[#0CBB7D]"
                            onClick={() => {
                              setModalDetails(
                                row.priceBreakup.working || row.priceBreakup
                              );
                              setModalOpen(true);
                            }}
                            title="Show price breakup"
                          >
                            <FaInfoCircle />
                          </button>
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Available Balance */}
                  <div className="grid grid-cols-[150px_10px_1fr] items-start text-gray-500">
                    <span className="font-[400]">Available Balance</span>
                    <span className="text-center">:</span>
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      {/* <span className="break-words">{row.type}</span> */}
                      <span className="font-semibold">
                        ₹{Number(row.balanceAfterTransaction).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  {/* Description */}
                  {row.description && (
                    <div className="grid grid-cols-[150px_10px_1fr] items-start text-gray-500">
                      <span className="font-[400]">Description</span>
                      <span className="text-center">:</span>
                      <span>{row.description}</span>
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between bg-green-100 text-[10px] text-gray-500 px-3 py-2 rounded-b-md">
                  <div className="flex items-center gap-2">
                    <img
                      src={carrierLogos[row.provider]}
                      alt="Courier"
                      className="w-5 h-5 rounded-full object-contain"
                    />
                    <span className="font-[600]">
                      {row.courierServiceName || ""}
                    </span>
                  </div>
                  <div>
                    AWB:{" "}
                    <span
                      className="font-[600] text-[#0CBB7D]"
                      onClick={() => {
                        handleTrackingByAwb(row.awb_number);
                      }}
                    >
                      {row.awb_number || "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-4">No data found</div>
        )}
      </div>

      {/* Limit Selector & Pagination */}
      {/* Pagination Controls */}
      <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
        <div className="flex items-center gap-2">
          <label
            htmlFor="limit"
            className="text-gray-700 text-[10px] font-[600]"
          >
            Show:
          </label>
          <select
            id="limit"
            value={limit}
            onChange={(e) => {
              const selected = e.target.value;
              if (selected === "All") {
                setLimit("All"); // null means no limit
                setPage(1);
              } else {
                setLimit(parseInt(selected));
                setPage(1); // reset to first page when changing limit
              }
            }}
            className="px-3 py-2 border rounded-md text-[10px] font-[600]"
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
            <option value="All">All</option>
          </select>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowLeft />
          </button>
          <span className="text-gray-700">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowRight />
          </button>
        </div>
      </div>
      <ChargeBreakdownModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        details={modalDetails}
      />
    </div>
  );
};

export default Passbooks;
